package uz.ferro.erp.feature.customer.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.customer.model.CustomerDto

object CustomerRepository {
    suspend fun getCustomers(): List<CustomerDto> {
        return suspendGet("customer/list")
    }
}